import { render, staticRenderFns } from "./ProTemplate.vue?vue&type=template&id=ce399360&scoped=true&"
import script from "./ProTemplate.vue?vue&type=script&lang=js&"
export * from "./ProTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce399360",
  null
  
)

export default component.exports